module.exports = __webpack_public_path__ + "media/components/assets/icons/rank/top3-731362e52c5170cd4674a04fed2fc088.svg";